var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button-group',_vm._l((_vm.$store.getters.getLanguages),function(l,i){return _c('b-button',{key:i,attrs:{"variant":_vm.isActive(l),"size":"sm"},on:{"click":function($event){_vm.$emit('languageKey', l);
      _vm.activeLanguage = l;}}},[_vm._v(" "+_vm._s(l)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }